import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SearchBar from '../search/search-bar';
import { withStyles } from '@material-ui/core/styles';
import PenIcon from '@material-ui/icons/CreateOutlined';
import PhotoIcon from '@material-ui/icons/AddAPhotoOutlined';
import VideoIcon from '@material-ui/icons/VideocamOutlined';
import ContentIcon from '@material-ui/icons/ClassOutlined';
import ThumbUpIcon from '@material-ui/icons/ThumbUpOutlined';
import CommentIcon from '@material-ui/icons/CommentOutlined';
import Typography from '@material-ui/core/Typography';
import { Button, CustomBadge } from '../../components';
import { ThemeColors } from '../../theme';
import Grid from '@material-ui/core/Grid';
import Avatar from '@material-ui/core/Avatar';
import FaceIcon from '@material-ui/icons/Face';
import moment from 'moment';
import Youtube from 'react-youtube';
import ArrowDown from '@material-ui/icons/ArrowDropDown';
import Popover from '@material-ui/core/Popover';
import Radio from '@material-ui/core/Radio';
import NotificationIcon from '@material-ui/icons/NotificationImportantOutlined';
import IconButton from '@material-ui/core/IconButton';
import Badge from '@material-ui/core/Badge';
import getTimePassed from '../../util/passedTime';
import Notification from './notification';

class NotificationCenter extends Component {

  constructor(props) {
    super(props);
    this.state = {
      popoverOpen: false,
    };
  }

  componentWillMount() {

  }

  getEntryUpdates = () => {
    const entries = this.props.notifications.filter(f => f.state === 'New');

    if (entries && entries.length > 0) {
      const entriesToUpdate = entries.map(e => (
        {
          id: e.id,
          state: 'Seen',
        }
          ));

      // this.props.setNotificationStates(entriesToUpdate);
      return entriesToUpdate;
    }

    return [];
  }

  gotoDetailedNotificationView = () => {
    this.handleClosePopover();
    this.props.history.push('/notificationcenter');
  }

  handleOpenPopover = (event) => {
    this.handleUpdateNewStates();
    this.setState({
      popoverOpen: this.state.popoverOpen ? null : event.currentTarget,
    });
  }

  handleClosePopover = () => {
    this.props.loadNotifications();
    this.setState({
      popoverOpen: false,
    });
  }

  handleOnNotificationSelected = (notification) => {
    this.props.history.push(`/socialwall/${notification.linkId}`);
    this.handleClosePopover();
    this.handleUpdateStateForNotification(notification);
  }

  handleUpdateStateForNotification = (notification) => {
    const entry = {
      id: notification.id,
      state: 'Opened',
    };

    if (notification.state !== entry.state) { this.props.updateState([entry]); }
    // this.props.setNotificationStates([entry]);
  }

  handleUpdateNewStates = () => {
    const entries = this.getEntryUpdates();

    if (entries.length > 0) this.props.updateState(entries);
  }

  renderPopOver() {
    const { classes } = this.props;

    return (
      <Popover
        open={this.state.popoverOpen}
        anchorEl={this.state.popoverOpen}
        onClose={this.handleClosePopover}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <div className={classes.popoverStyle}>
          <Typography className={classes.titleStyle}>Benachrichtigungen</Typography>
          {this.renderNotifications()}
          {this.renderShowAllButton()}
        </div>
      </Popover>
    );
  }

  renderShowAllButton() {
    return (
      <Button
        variant="text"
        onClick={this.gotoDetailedNotificationView}
        style={{
          borderTop: 'lightgrey 1px solid',
          textTransform: 'none',
          textAlign: 'center',
          width: '100%',
          marginTop: 5,
          fontWeight: 'bold',
          color: ThemeColors.primary1Color }}
        label="Alle ansehen"
      />
    );
  }

  renderNotifications() {
    const textStyle = {
      paddingTop: 10,
      paddingBottom: 5,
      paddingLeft: 20,
      paddingRight: 20,
      fontWeight: 'bold',
    };

    const entriesNotSeen =
        this.props.notifications
            .filter(f => f.state === 'New')
            .map(n =>
              <Notification
                notification={n}
                handleOnNotificationSelected={this.handleOnNotificationSelected}
              />);

    let entriesSeen =
        this.props.notifications
            .filter(f => f.state !== 'New')
            .map(n =>
              <Notification
                notification={n}
                handleOnNotificationSelected={this.handleOnNotificationSelected}
              />);


    if (entriesSeen.length >= 5) {
      entriesSeen = entriesSeen.slice(0, 4);
    }

    return (
      <div>
        <Typography style={textStyle}>Neu</Typography>
        <div style={{ flex: 1 }}>
          {entriesNotSeen}
        </div>

        <div style={{ flex: 1 }}>
          <Typography style={textStyle}>Gesehen</Typography>
          {entriesSeen}
        </div>
      </div>

    );
  }


  render() {
    const { classes } = this.props;

    if (this.props.config &&
      (!this.props.config.socialWallActive ||
      !(this.props.config.socialWallActive === 'true'))) {
      return null;
    }

    const newNotifications = this.props.notifications
    ? this.props.notifications.filter(f => f.state === 'New').length
    : 0;

    return (
      <div>
        <CustomBadge
          onClick={this.handleOpenPopover}
          iconStyle={{ marginTop: 10 }}
          icon={<NotificationIcon style={{ fontSize: 24, color: ThemeColors.accent1Color }} />}
          content={newNotifications}
        />
        {this.renderPopOver()}
      </div>

    );
  }
}

NotificationCenter.propTypes = {
};

const styles = theme => ({
  badgeStyle: {
    transform: 'scale(0.7) translate(30%, 0%)',
  },
  popoverStyle: {
    padding: 10,
    width: 350,
  },
  titleStyle: {
    fontSize: 16,
    color: theme.palette.primary.main,
    textAlign: 'center',
    fontWeight: 'bold',
  },
});

export default withStyles(styles)(NotificationCenter);



// WEBPACK FOOTER //
// ./src/app/main/notification-center/notification-center-popup.js